interface OrganisationForRouting {
  organisationType?: string
  isOnboarded?: boolean
}

export const getPostLoginPath = (org?: OrganisationForRouting): string => {
  if (org?.organisationType === "property_investment" && !org?.isOnboarded) {
    return "/welcome"
  }
  return org?.organisationType === "property_investment" ? "/portfolio" : "/dashboard"
}
